import { PERMISSIONS, userHasPermission } from 'constants/permissions';

export function isImagingRoleUser(user) {
  return String(user?.role || '').toLowerCase() === 'imaging' || Boolean(user?.isImaging);
}

/**
 * Врач, узист, хирург, анестезиолог — «Приём» с разделением амбулатория / стационар.
 * Регистратура и директор остаются с обычными вкладками.
 */
export function usesDoctorReceptionHub(user) {
  if (!user) return false;
  const role = String(user.role || '').toLowerCase();
  return (
    role === 'doctor' ||
    role === 'surgeon' ||
    role === 'anesthesiologist' ||
    role === 'imaging' ||
    Boolean(user.isDoctor) ||
    Boolean(user.isSurgeon) ||
    Boolean(user.isAnesthesiologist)
  );
}

function canSeeInpatientSection(user) {
  return (
    userHasPermission(user, PERMISSIONS.SCHEDULE) ||
    userHasPermission(user, PERMISSIONS.MEDICAL_RECORDS) ||
    userHasPermission(user, PERMISSIONS.CLIENTS)
  );
}

function withImagingScheduleSidebar(routes, user) {
  if (!isImagingRoleUser(user)) return routes;

  const mapped = routes.map((route) => {
    if (route.path !== '/schedule') return route;
    return { ...route, hideInSidebar: false };
  });

  const scheduleIdx = mapped.findIndex((route) => route.path === '/schedule');
  const receptionIdx = mapped.findIndex((route) => route.path === '/reception');
  if (scheduleIdx < 0 || receptionIdx < 0 || scheduleIdx === receptionIdx + 1) {
    return mapped;
  }

  const next = [...mapped];
  const [schedule] = next.splice(scheduleIdx, 1);
  const insertAt = next.findIndex((route) => route.path === '/reception') + 1;
  next.splice(insertAt, 0, schedule);
  return next;
}

/** Для врача: «Приём» — Амбулаторные / Стационарные. Узист дополнительно видит своё «Расписание». */
export function transformDoctorSidebarRoutes(routes, user) {
  if (!usesDoctorReceptionHub(user)) return routes;

  const withReception = routes.map((route) => {
    if (route.path !== '/reception' || !route.component) return route;

    const items = [];

    if (userHasPermission(user, PERMISSIONS.UPCOMING_APPOINTMENTS)) {
      items.push({
        name: 'Амбулаторные',
        layout: '/admin',
        path: '/reception',
        sidebarSection: 'ambulatory',
        permissions: [PERMISSIONS.UPCOMING_APPOINTMENTS],
        component: route.component,
      });
    }

    if (canSeeInpatientSection(user)) {
      items.push({
        name: 'Стационарные',
        layout: '/admin',
        path: '/reception',
        sidebarSection: 'inpatient',
        permissions: [
          PERMISSIONS.SCHEDULE,
          PERMISSIONS.MEDICAL_RECORDS,
          PERMISSIONS.CLIENTS,
        ],
        component: route.component,
      });
    }

    if (items.length === 0) return route;

    return {
      ...route,
      collapse: true,
      items,
    };
  });

  return withImagingScheduleSidebar(withReception, user);
}
